<template src="./defectsPage.html"></template>

<script>
export default {
    name: 'defects-page',
    props: ['currentSelectedTab', 'observations'],
    data() {
        return {

        }
    },
    computed: {
        sortedObservations() {
            return this.observations.sort((a,b) => a.Distance - b.Distance);
        },
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        structuralGrades() {
            return this.session.PacpRatings.PacpStructuralGrades;
        },
        maintenanceGrades() {
            return this.session.PacpRatings.PacpMaintenanceGrades;
        },
        overallGrades() {
            return this.session.PacpRatings.PacpOverallGrades;
        },
        maintenanceCounts() {
            let counts = {
                Severe: 0,
                Heavy: 0,
                Average: 0,
                Moderate: 0,
                Light: 0,
                Overall: 0,
                NumDefects: 0
            };
            
            return counts;
        },
        structuralCounts() {
            let counts = {
                Severe: 0,
                Heavy: 0,
                Average: 0,
                Moderate: 0,
                Light: 0,
                Overall: 0,
                NumDefects: 0
            };

            return counts;
        }
    },
    methods: {
        getFieldValueForTable(observation, fieldName) {
            let field = observation.Fields.find((fld) => fld.Name === fieldName);

            if (field) {
                if (field.Value === true) {
                    return 'X';
                }
                if (field.Value === false) {
                    return '';
                }

                return field.Value;
            }

            return '';
        }
    }
}

</script>
